<template>
  <StepDescription :stepDescription="'Cadastre uma conta bancária da qual você seja o titular, ou uma conta de Pessoa Jurídica.'"/>
  <FormKit
    type="form"
    :value="{
      bank_account_type: 'C',
      bank_code: '',
      cnpj: '',
      bank_account_holder_name: '',
      bank_branch_number: '',
      bank_branch_digit: '',
      bank_account_number: '',
      bank_account_digit: ''
    }"
    submit-label="Continuar" @submit="confirmData"
  >

    <FormKit
      type="checkbox"
      name="titular_pj"
      label="Titular Pessoa Jurídica?"
      v-model="titular_pj"
    />
    <FormKit
      type="text"
      v-model="cnpj"
      v-show="titular_pj"
      name="cnpj"
      id="cnpj"
      ref="cnpjInput"
      label="CNPJ*"
      maxlength="18"
      placeholder="CNPJ"
      @change="(event) => normalizeField(event, normalizeCNPJ, () => cnpjInput.node)"
      :disabled="!titular_pj"
      :validation="titular_pj ? 'required|cnpj' : ''"
    />
    <FormKit
      type="text"
      v-model="razaoSocial"
      v-show="titular_pj"
      name="bank_account_holder_name"
      id="bank_account_holder_name"
      label="Razão social*"
      maxlength="100"
      :disabled="!titular_pj"
      :validation="titular_pj ? 'required' : ''"
    />

    <FormKit
      type="select"
      name="bank_code"
      id="bank_code"
      label="Banco"
      validation="required">
    </FormKit>

    <div class="bankAccount">
      <div class="bankAccount_agencia">
        <FormKit
          type="text"
          name="bank_branch_number"
          id="bank_branch_number"
          label="Agência (sem dígito)*"
          validation="required|length:4,4|only_digits"
          ref="branchNumberInput"
          @change="(event) => normalizeField(event, normalizeBranch, () => branchNumberInput.node)"
          validation-label="Agência"
        />
      </div>
      <div class="bankAccount__digito">
        <FormKit
          type="text"
          name="bank_branch_digit"
          id="bank_branch_digit"
          label="Dígito"
          maxlength="2"
          validation="length:1,2"
          validation-label="Dígito da agência"
          ref="branchDigitInput"
          @change="(event) => normalizeField(event, normalizeDigit, () => branchDigitInput.node)"
        />
      </div>
    </div>

    <div class="bankAccount">
      <div class="bankAccount_conta">
        <FormKit
          type="text"
          name="bank_account_number"
          label="Conta (sem dígito)*"
          maxlength="15"
          validation="required|length:3,15|only_digits"
          validation-label="Número da conta"
        />
      </div>
      <div class="bankAccount__digito">
        <FormKit
          type="text"
          name="bank_account_digit"
          id="bank_account_digit"
          label="Dígito*"
          maxlength="2"
          :validation="[['required'], ['length', 1, 2], ['matches', /^[0-9]{2}$|^[0-9X]$/i]]"
          validation-label="Dígito da conta"
          :validation-messages="{
            matches: 'Use apenas dígitos ou X'
          }"
          ref="accountDigitInput"
          @change="(event) => normalizeField(event, normalizeDigit, () => accountDigitInput.node)"
        />
      </div>
    </div>

    <FormKit
      type="select"
      name="bank_account_type"
      id="bank_account_type"
      label="Tipo de conta"
      value="bank_account_type"
      :options="{C: 'Conta corrente', P: 'Conta poupança', Pag: 'Conta de pagamentos' }"
    />
    <template #submit>
      <FooterButton />
    </template>
  </FormKit>
</template>
<script>
  import FooterButton from '../../components/FooterButton.vue';
  import StepDescription from '@/cadastro/components/StepDescription.vue';
  import { useStore } from '../../../stores/cadastro.js';
  import { useRouter } from 'vue-router'
  import { onMounted, ref, watch } from 'vue';
  import axios from 'axios';
  import Swal from 'sweetalert2';
  import { normalizeField } from '@/lib/formkit/formkitUtil';
  import TomSelect from 'tom-select';

  export default {
    components: {
      FooterButton,
      StepDescription
    },
    setup() {
      const store = useStore();
      const router = useRouter();

      const titular_pj = ref(false);
      const cnpj = ref('');
      const razaoSocial = ref('');
      const cnpjInput = ref(null);
      const branchNumberInput = ref(null);
      const branchDigitInput = ref(null);
      const accountDigitInput = ref(null);

      watch(titular_pj, (newValue) => {
        if (!newValue) {
          cnpj.value = '';
          razaoSocial.value = '';
        }
      });

      let banksPromise;

      const getBanks = async () => {
        await store.fetchBanks();
        return store.banksList;
      }

      async function loadBanks(query, callback) {
        banksPromise.then((item) => callback(item))
      }

      function setupBankCodeSelect() {
        const elem = '#bank_code';

        const itemRenderFn = (data, escape) => {
          return `<div>${escape(data.name)} (${escape(data.code)})</div>`;
        };

        new TomSelect(elem, {
          load: loadBanks,
          preload: true,
          valueField: 'code',
          labelField: 'name',
          searchField: ['name', 'code'],
          placeholder: 'Banco',
          loadThrottle: null,
          render: {
            item: itemRenderFn,
            option: itemRenderFn,
          },
        });
      }

      onMounted(async () => {
        banksPromise = getBanks();
        setupBankCodeSelect();
      });

      const confirmData = async (formData) => {
        await store.updateBankData(formData);
        const data = store.getBankData;
        data.registration_steps = { bank_data: true };
        const driverId = store.getDriverId;

        try {
          const response = await axios.post(`/cadastro-motorista/update/${driverId}`, {
            data: data
          });
          if (response.data && response.data.id) {
            store.setDriverId(response.data.id);
          }
          Swal.fire({
            title: 'Dados enviados com sucesso!',
            text: 'Seus dados bancários foram salvos, por favor informe o restante dos dados nos passos seguintes.',
            icon: 'success',
            allowOutsideClick: false,
            timer: 10000,
            timerProgressBar: true,
            showConfirmButton: true,
            confirmButtonText: 'Ok'
          }).then(() => {
            if (response.status == 200) {
              router.push({ name: 'StatusRegistration' });
            }
          });
        } catch (error) {
          if (error.response && error.response.status === 409) {
            router.push({ name: 'WarningScreen' });
          } else {
            Swal.fire({
              title: 'Ops...',
              text: 'Erro inesperado, por favor tente novamente mais tarde.',
              icon: 'error',
              confirmButtonText: 'Ok'
            });
          }
        }
      }

      return {
        confirmData,
        normalizeField,
        titular_pj,
        cnpjInput,
        cnpj,
        razaoSocial,
        branchNumberInput,
        branchDigitInput,
        accountDigitInput,
      };
    },
    data() {
      return {
        bank_account_type: '',
        bank_code: '',
        bank_account_holder_name: '',
        bank_branch_number: '',
        bank_branch_digit: '',
        bank_account_number: '',
        bank_account_digit: ''
      }
    },
    methods: {
      normalizeCNPJ(cnpj) {
        return cnpj.replace(/\D/g, '')
          .replace(/^(\d{2})(\d)/, '$1.$2')
          .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
          .replace(/\.(\d{3})(\d)/, '.$1/$2')
          .replace(/(\d{4})(\d)/, '$1-$2')
        ;
      },
      normalizeBranch(value) {
        let branch = value.trim();
        if (branch !== '' && branch.length < 4) {
          return branch.padStart(4, '0');
        }
        return branch;
      },
      normalizeDigit(digit) {
        return digit.toUpperCase();
      },
    }
  }

</script>
